// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { every, get } from 'lodash'
import React from 'react'
import { formatAddress } from '../../../../common/utils'
import { FormInput } from '../../../../LEGACY/elemental'
import { FormFieldLayout } from '../../../generic'
import AddressSearch from './AddressSearch'

export default class AddressField extends React.Component {
  state = {
    hasSelectedAddress: false,
    isEditingAddress: false,
    isTypingManually: false
  }

  getValue = (key) => {
    const { formKey, values } = this.props
    return get(values, `${formKey}.${key}`)
  }

  handleChange = (key, e) => {
    const { formKey, onChange } = this.props
    if (!this.state.isEditingAddress) {
      this.setState({ isEditingAddress: true })
    }
    onChange({
      key: `${formKey}.${key}`,
      value: e.target.value
    })
  }

  handleSearchSelect = (address) => {
    this.props.onChange({ key: this.props.formKey, value: address })
    this.setState({
      hasSelectedAddress: true
    })
  }

  isEmpty = (fields) =>
    !fields ||
    !Object.keys(fields).length ||
    every(fields, (field) => field === null)

  renderFormattedAddress = (addressFields) => {
    return (
      <div>
        <div className="formatted-address">{formatAddress(addressFields)}</div>
        <a
          onClick={() =>
            this.setState({
              isEditingAddress: true,
              isTypingManually: true
            })
          }
          style={styles.link}
        >
          Change address <span className="octicon octicon-chevron-right" />
        </a>
      </div>
    )
  }

  renderPostcodeSearch = (isShowingFields) => (
    <div style={{ paddingTop: isShowingFields ? 20 : null }}>
      <FormFieldLayout isNestedField label="Postcode">
        <AddressSearch
          isShowingFields={isShowingFields}
          onChange={(e) => this.handleChange('postcode', e)}
          onSelect={this.handleSearchSelect}
          onShowFields={() => this.setState({ isTypingManually: true })}
          value={this.getValue('postcode') || ''}
        />
      </FormFieldLayout>
    </div>
  )

  renderField = (field, idx) => (
    <div key={idx} style={idx > 0 ? styles.nestedField : null}>
      <FormFieldLayout isNestedField label={field.label}>
        <FormInput
          onChange={(e) => this.handleChange(field.value, e)}
          value={this.getValue(field.value) || ''}
          data-testid={
            this.props['data-testid']
              ? `${this.props['data-testid']}-${field.value}`
              : undefined
          }
        />
      </FormFieldLayout>
    </div>
  )

  render() {
    const { formKey, isNestedField, label, required, style, values } =
      this.props

    const { hasSelectedAddress, isEditingAddress, isTypingManually } =
      this.state

    if (!values) return null

    const addressFields = values[formKey]
    const isDisplayingAddress =
      !this.isEmpty(addressFields) && !isEditingAddress

    if (isDisplayingAddress)
      return (
        <div style={style}>
          <FormFieldLayout
            isNestedField={isNestedField}
            label={label}
            required={required}
          >
            {this.renderFormattedAddress(addressFields)}
          </FormFieldLayout>
        </div>
      )

    const isShowingFields = isTypingManually || hasSelectedAddress

    return (
      <div style={style}>
        {!isNestedField && (
          <div style={styles.label}>
            {label} {required && <span style={{ color: colors.red }}>*</span>}
          </div>
        )}
        <div style={{ paddingTop: isNestedField ? null : 10 }}>
          {isShowingFields && FIELDS.map(this.renderField)}
          {this.renderPostcodeSearch(isShowingFields)}
        </div>
      </div>
    )
  }
}

const FIELDS = [
  { value: 'name', label: 'Building Name' },
  { value: 'street1', label: 'Address Line 1' },
  { value: 'street2', label: 'Address Line 2' },
  { value: 'suburb', label: 'Town / City' },
  { value: 'state', label: 'County' }
]

const styles = {
  formRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  label: {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 10
  },
  link: {
    textDecoration: 'none'
  },
  nestedField: {
    paddingTop: 20
  }
}
